export const computeFifoDistribution = (invoices, amount) => {
  let remaining = Number(amount || 0);
  const out = {};
  const ordered = [...(invoices || [])].sort((a, b) => new Date(a?.created_at || 0) - new Date(b?.created_at || 0));

  ordered.forEach((inv) => {
    const saldo = Number(inv?.saldo_pendiente || 0);
    if (remaining <= 0) {
      out[inv.id] = 0;
      return;
    }
    const apply = Math.min(saldo, remaining);
    out[inv.id] = Number(apply.toFixed(2));
    remaining = Number((remaining - apply).toFixed(2));
  });

  return { distribution: out, remaining };
};

